export { default } from './SnapdocsClosingSection';
